export const NO_DESCRIPTION_SET_COLLECTION_LABEL = "No description set";
